import { useIntl } from "react-intl"
import useSubmissionHttpLogs from "../hooks/useSubmissionHttpLogs"
import HttpLogItem from "./HttpLogItem"

export default function LogsPanel({ selectedJob, startTime, endTime, refreshToken }) {
  const intl = useIntl()
  const jobId = selectedJob?.id

  const { logs, status, loading, error } = useSubmissionHttpLogs({
    jobId,
    startTime,
    endTime,
    limit: 1000,
    refreshToken,
  })

  const renderLogs = () => {
    return logs.map((log) => <HttpLogItem key={log.logId} log={log} />)
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm ">
      <div className="p-6 border-b border-gray-200">
        <h3 className="text-lg font-semibold">
          {intl.formatMessage({ id: "dga.logs.httpLogs", defaultMessage: "HTTP Logs" })}
        </h3>
        <p className="text-sm text-gray-600 mt-1">
          {jobId
            ? intl.formatMessage(
              { id: "dga.logs.subtitle", defaultMessage: "Recent activity and events for {name}" },
              { name: selectedJob?.name || selectedJob?.region_code || jobId }
            )
            : intl.formatMessage({ id: "dga.logs.selectJob", defaultMessage: "Select a job to show logs" })}
        </p>
      </div>
      <div className="p-2 sm:!p-6">
        {!jobId ? (
          <div className="h-[300px] flex items-center justify-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 text-sm text-gray-600">
            {intl.formatMessage({ id: "dga.logs.selectJob", defaultMessage: "Select a job to show logs" })}
          </div>
        ) : (
          <>
            {error && (
              <div className="text-sm text-red-600 mb-3">
                {intl.formatMessage(
                  { id: "dga.logs.failed", defaultMessage: "Failed to load logs: {msg}" },
                  { msg: String(error.message || error) }
                )}
              </div>
            )}
            {loading && (
              <div className="text-sm text-gray-500 mb-3">
                {intl.formatMessage({ id: "dga.logs.loading", defaultMessage: "Loading logs…" })}
              </div>
            )}
            {status && !loading && (
              <div className="text-xs text-gray-500 mb-2">
                {intl.formatMessage({ id: "dga.logs.status", defaultMessage: "Status" })}: {status}
              </div>
            )}

            {(logs?.length ?? 0) === 0 && !loading ? (
              <div className="h-[300px] flex items-center justify-center bg-gray-50 rounded-lg border-2 border-dashed border-gray-300 text-sm text-gray-600">
                {intl.formatMessage({ id: "dga.logs.empty", defaultMessage: "No logs found for the selected range." })}
              </div>
            ) : (
              <div className="h-[500px] overflow-y-scroll">
                <div className="space-y-3">
                  {renderLogs()}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
